import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { ModalComponent } from '../components/modal.component';
import { ModalData } from '../models/modal.types';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private dialog = inject(MatDialog);

  openDialog(data: ModalData): Observable<any> {
    const dialogRef = this.dialog.open(ModalComponent, {
      panelClass: 'tux-modal',
      backdropClass: 'tux-modal-backdrop',
      disableClose: true,
      autoFocus: false,
      data,
    });
    return dialogRef.afterClosed().pipe(take(1));
  }
}
